const data = {
    "numero-cliente": {
      label: "Numero cliente",
      description: "È il codice associato alla tua fornitura. Utilizzalo in tutte le comunicazioni, saremo più rapidi nel darti le risposte e le informazioni di cui hai bisogno.",
      labelKeywords: ["numero", "cliente"],
      contentKeywords: ["numero", "cliente"],
      img: "./images/01-testata-03-daticliente-01-numerocliente.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziato il campo Numero Cliente"
    },

    "codice-fiscale": {
      label: "Codice Fiscale/Partita IVA",
      description: "Qui trovi il codice fiscale e/o Partita IVA di chi ha sottoscritto il contratto di fornitura di energia elettrica.",
      labelKeywords: ["codice", "fiscale", "CF"],
      contentKeywords: ["codice", "fiscale", "CF"],
      img: "./images/01-testata-03-daticliente-02-codicefiscale.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziato il campo Codice fiscale o Partita IVA"
    },

    "codice-pod": {
      label: "Codice POD",
      description: "È un codice alfanumerico di 15 caratteri che identifica in maniera univoca il tuo contatore. POD deriva dall'inglese \"Point of Delivery\" ossia \"punto di prelievo\".",
      labelKeywords: ["codice", "POD"],
      contentKeywords: ["codice", "POD"],
      img: "./images/01-testata-03-daticliente-03-codicepod.jpg",
      imgDescription: "Immagine che raffigura la prima pagina della bolletta, con evidenziato il campo Codice POD"
    }
}

export default data;